import { render, staticRenderFns } from "./ProductToCuration.vue?vue&type=template&id=5d3e1c9e&scoped=true"
import script from "./ProductToCuration.vue?vue&type=script&lang=js"
export * from "./ProductToCuration.vue?vue&type=script&lang=js"
import style0 from "./ProductToCuration.vue?vue&type=style&index=0&id=5d3e1c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3e1c9e",
  null
  
)

export default component.exports